import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ID, LyaAutoInterviewCandidateMeta, QuestionResponse } from '../state/lya.types';

@Injectable({
  providedIn: 'root',
})
export class LyaService {
  constructor(private http: HttpClient) {}

  getCandidateInterviewMeta(
    data: string,
    companyId?: string,
  ): Observable<LyaAutoInterviewCandidateMeta> {
    //add header company id
    const header = new HttpHeaders({
      company_id: companyId ?? 'anonymous',
    });
    return this.http.get<LyaAutoInterviewCandidateMeta>(`/lya/auto-interview-p/find/${data}`, {
      headers: header,
    });
  }

  getCompanyPublicData(companyId: string): Observable<{ id: string; logoUrl: string | null }> {
    return this.http.get<{ id: string; logoUrl: string | null }>(
      `/hub/company-p-data/${companyId}`,
    );
  }

  sendCV(id: string, fileCV: File): Observable<ID<string>> {
    const formData = new FormData();
    formData.append('file', fileCV);
    return this.http.post<ID<string>>(`/lya/send-cv/${id}`, formData);
  }

  attachCV(companyId: string, key: string, fileCV: File): Observable<ID<string>> {
    const formData = new FormData();
    formData.append('file', fileCV);
    const header = new HttpHeaders({
      company_id: companyId ?? 'anonymous',
    });
    return this.http.post<ID<string>>(`/lya/auto-interview-p/attach/${key}`, formData, {
      headers: header,
    });
  }

  questionResponse(companyId: string, response: QuestionResponse): Observable<void> {
    const header = new HttpHeaders({
      company_id: companyId ?? 'anonymous',
    });
    return this.http.post<void>(`/lya/auto-interview-p/question-response`, response, {
      headers: header,
    });
  }
}
